document.addEventListener("DOMContentLoaded", function(e) {
  var elem = document.querySelector("#product-infos");
  var stickyFormContainer = document.querySelector(".sticky-form-container");
  if (elem != null && stickyFormContainer != null) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: elem,
        start: 'top+=100% top',
        markers: false,
        scrub: 1,
        onEnter: () => {
          stickyFormContainer.classList.add("sticky-form");
        },
        onEnterBack: () => {
          stickyFormContainer.classList.remove("sticky-form");
        }
      }
    });
    console.log('sticky menu');
  }
});
